import {
  IUserReaction,
  IGetUsersReactionsForMessage,
  IUsersReactionsForMessage,
} from '@gem/models/reactionsModel';
import { logger } from '@gem/modules/logger';

import { WsRequestError } from 'APP/model/error/errors/WsRequestError';
import { MessageModelErrorCode } from 'APP/model/message/messageModel.types';
import { ServerErrorCode } from 'APP/restApi/constants/constants';
import { GroupServerErrorCode } from 'APP/restApi/constants/group.errors';
import {
  getUserReactionsRequest,
  getUserReactionsForMessageRequest,
} from 'APP/wsApi/wsAppApi/requests/reactionRequests';

import { buildModelError } from '../error/errorBuilder';
import { mapReactionToUserReaction } from './reactionsModel.b2b.mapper';

export const getUserReactions = async (): Promise<IUserReaction[]> => {
  try {
    const result = await getUserReactionsRequest({});

    return result.type.case === 'success'
      ? result.type.value.reactions.map(mapReactionToUserReaction)
      : [];
  } catch (error) {
    logger.get('API').error('reactions.getUserReactions', error);
    throw buildModelError(error);
  }
};

export async function getUsersReactionsForMessage(
  data: IGetUsersReactionsForMessage
): Promise<IUsersReactionsForMessage> {
  try {
    const result = await getUserReactionsForMessageRequest({
      chatId: BigInt(data.groupId),
      messageId: BigInt(data.messageId),
      reactionId: data.reactionId ? BigInt(data.reactionId) : undefined,
    });

    switch (result.type.case) {
      case 'chatIsUnavailable':
        throw new WsRequestError(GroupServerErrorCode.GroupIsUnavailable, result);
      case 'userChatRelationshipDoesNotExist':
        throw new WsRequestError(GroupServerErrorCode.UserGroupRelationshipDoesNotExist, result);
      case 'hasNoPermissionsToPerformAction':
        throw new WsRequestError(ServerErrorCode.HasNoPermissionsToPerformAction, result);
      case 'messageDoesNotExist':
        throw new WsRequestError(MessageModelErrorCode.MessageDoesNotExist, result);
    }

    return (result.type.value?.usersReactions || []).reduce<IUsersReactionsForMessage>(
      (acc, reaction) => {
        return {
          ...acc,
          [String(reaction.reactionId)]: reaction.userIds.map((id) => String(id)),
        };
      },
      {}
    );
  } catch (error) {
    logger.get('API').error('messaging.getUsersReactionsForMessage', error);
    throw buildModelError(error);
  }
}
